<template>
    <div>
        <div class="form-inline" v-for="(v, key) in value">
            <div class="form-group">
                <label>{{ titles[0] }}</label>
                <input type="text" class="form-control" :name="name + '[' + key + '][title]'" v-model="v[0]">
            </div>
            <div class="form-group">
                <label>{{ titles[1] }}</label>
                <input type="text" class="form-control" :name="name + '[' + key + '][value]'" v-model="v[1]">
                <button type="button" v-on:click.bind="deleteRow(key)" class="btn btn-danger btn-sm">刪除</button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      'titles': Array,
      'name': String,
      'default-value': {
        default: {}
      },
    },
    data() {
      return {
        'value': []
      };
    },
    mounted() {
      Object.keys(this.defaultValue).forEach((key) => {
        if (Number.isInteger(parseInt(key))) {
          let data = [];
          Object.keys(this.defaultValue[key]).forEach((subkey) => {
            data.push(this.defaultValue[key][subkey]);
          });
          if (data[0] !== null) {
            this.value.push(data);
          }
        } else {
          this.value.push([key, this.defaultValue[key]]);
        }
      });
      if (this.defaultValue.length === 0) {
        this.value.push(['', '']);
      }
    },
    methods: {
      deleteRow: function (rowId) {
        this.value.splice(rowId, 1);
      }
    },
    watch: {
      value: function (value) {
        let length = value.length;

        if (value[length - 1][0] !== '' && value[length - 1][0] !== '') {
          value.push(['', '']);
        }
      },
    }
  }
</script>
